var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"report"},[_c('msp-app-bar',{attrs:{"title":"Report"}}),_c('msp-report'),_c('msp-app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }